// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import ScoreGauge from 'components/product/ScoreGauge'
import styles from './OwnerDial.module.css'

interface OwnerDialProps {
  yes: number
  total: number
  /** Percent inside the ring past the gate; "6 of 7" under it. */
  gateMet: boolean
  className?: string
}

/**
 * The buy-again dial (design "Owner notes at the top of the page", 2026-09-22): the hero's
 * score gauge in its violet variant — neutral, no good/bad colour meaning — with the
 * "Buy again / OWNER REPORTED" caption, on the rail card and in the owners section.
 * Owner-reported, never a lab score — the caption says so.
 */
const OwnerDial: React.VFC<OwnerDialProps> = ({ yes, total, gateMet, className }) => {
  const pct = total > 0 ? Math.round((yes / total) * 100) : 0
  return (
    <ScoreGauge
      className={className ? `${styles.dial} ${className}` : styles.dial}
      variant="violet"
      value={yes}
      max={total}
      valueText={gateMet ? `${pct}%` : `${yes}`}
      maxText={`of ${total}`}
      label="Buy again"
      sub="Owner reported"
      ringAriaLabel={`${yes} of ${total} owners would buy it again`}
    />
  )
}

export default OwnerDial
